// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function promise(procedure) {
  return new Promise((function (resolve, reject) {
                try {
                  return procedure(function (result) {
                              resolve(result);
                            });
                }
                catch (raw_exn){
                  var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  return reject(exn);
                }
              }));
}

function promiseFlatMap(promise, mapper) {
  return promise.then(mapper);
}

function promiseMap(promise, mapper) {
  return promise.then(function (value) {
              return Promise.resolve(mapper(value));
            });
}

function promiseResolved(value) {
  return promise(function (resolve) {
              resolve(value);
            });
}

exports.promise = promise;
exports.promiseFlatMap = promiseFlatMap;
exports.promiseMap = promiseMap;
exports.promiseResolved = promiseResolved;
/* No side effect */
